export default {
  ZH_HK: {
    empty: "沒有數據",
    topic: "學科",
    topicAnalysis: "題目分析",
    popular: "最受歡迎題目排行",
    type: "題目類型",
    question: "題目內容",
    numberOfAnswers: "答題次數",
    questionAnsweringTime: "答題時長",
    accuracy: "正確率",
    numberOfQuestions: "題目數量",
    answer: "回答",
    grade: "年級",
    reference: "參考"
  },
  zh_cn: {
    empty: "没有数据",
    topic: "科目",
    topicAnalysis: "题目分析",
    popular: "最受欢迎题目排行",
    type: "题目类型",
    question: "题目内容",
    numberOfAnswers: "答题次数",
    questionAnsweringTime: "答题时间",
    accuracy: "正确率",
    numberOfQuestions: "题目数量",
    answer: "回答",
    grade: "年级",
    reference: "參考"
  },
  EN: {
    empty: "No Data",
    topic: "Subject",
    topicAnalysis: "Question Analysis",
    popular: "Most Popular Questions",
    type: "Question Type",
    question: "Question",
    numberOfAnswers: "Number of Answers",
    questionAnsweringTime: "Avg. Answering Time",
    accuracy: "Accuracy",
    numberOfQuestions: "Number of Questions",
    answer: "Answer",
    grade: "Grade",
    reference: "Reference"
  },
  es: {
    empty: "No hay datos",
    topic: "Asignatura",
    topicAnalysis: "Análisis de preguntas",
    popular: "Preguntas más populares",
    type: "Tipo de pregunta",
    question: "Pregunta",
    numberOfAnswers: "Número de respuestas",
    questionAnsweringTime: "Tiempo promedio de respuesta",
    accuracy: "Precisión",
    numberOfQuestions: "Número de preguntas",
    answer: "Responder",
    grade: "Grado",
    reference: "Referencia"
  }
};
